module.exports = "/_next/static/images/payments_2-d29e8904589419e70187a179f9028e6c.png";